const PREFIX = "[Marketo]";

const hasValueToSet = (value) => value != null && value !== "" && value !== "not-set";

export const assertMktoGlobal = (name, getter) => {
    try {
        getter();
    } catch {
        throw new Error(
            `${PREFIX} ${name} is not defined. Include /corpweb2021/includes/ftls/marketoGlobals.ftl in the page footer.`,
        );
    }
};

export const assertHiddenFieldsOnForm = (form, fields, source) => {
    if (!fields || typeof fields !== "object") return;

    const formElements = form.getFormElem()[0].elements;
    const missingOnForm = Object.keys(fields).filter(
        (key) => hasValueToSet(fields[key]) && !formElements[key],
    );

    if (missingOnForm.length) {
        console.warn(
            `${PREFIX} Hidden field(s) from ${source} are not on this Marketo form: ${missingOnForm.join(", ")}`,
        );
    }
};
